import React, { useEffect, useState, useContext } from 'react'
import { styled } from '@mui/material/styles'
import Layout from '@/product/components/templates/Layout'

import { Button } from '@mui/material'

import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { useFormik } from 'formik'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import AlertContext from '@/product/context/alert/alertContext'
import {
    handleRedirectInternal,
    dateTimeFormatFunction,
} from '@/product/common/components'

// import FieldHeader from './FieldHeader'
import CustomSearch from '../../../components/molecules/CustomSearch'
import CustomTable from '../../../components/molecules/CustomTable'
import SettingContext from '@/product/context/setting/settingContext'
import ScheduledPickupContext from '@/product/context/scheduledPickup/scheduledPickupContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import OrderManager from './orderManage'
import AuthContext from '@/product/context/auth/authContext'
const PREFIX = 'ERP'

const classes = {
    root: `${PREFIX}-root`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))
function calculateRemainingTime2(startDate, endDate) {
    // Convert date strings to Date objects
    const startDateObj = new Date(startDate)
    const endDateObj = new Date(endDate)

    // Calculate the time difference in milliseconds
    const timeDiff = endDateObj.getTime() - startDateObj.getTime()

    // Convert time difference to days, hours, and minutes
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

    // Determine the appropriate time unit to display
    if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''}`.replace(/-/g, '')
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`.replace(/-/g, '')
    } else {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`.replace(/-/g, '')
    }
}

// Example usage

function calculateRemainingTime(targetDate) {
    // Convert target date string to Date object
    const endDate = new Date(targetDate)

    // Get the current date
    const now = new Date()

    // Calculate the time difference in milliseconds
    const timeDiff = endDate.getTime() - now.getTime()

    // Convert time difference to days, hours, and minutes
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

    // Determine the appropriate time unit to display
    if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''}`.replace(/-/g, '')
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''}`.replace(/-/g, '')
    } else {
        return `${minutes} minute${minutes > 1 ? 's' : ''}`.replace(/-/g, '')
    }
}

function formatDateToISOString(date) {
    return date.toISOString()
}

// Function to generate end_date string
function generateEndDate() {
    // Current date
    const currentDate = new Date()

    // Set end date to end of the day (23:59:59)
    const endDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        23,
        59,
        59
    )

    // Adjust for timezone offset
    const timezoneOffset = currentDate.getTimezoneOffset()
    endDate.setMinutes(endDate.getMinutes() - timezoneOffset)

    // Format date to ISO 8601 string
    return formatDateToISOString(endDate)
}

// Example usage

const AllOrders = (props) => {
    const settingcontext = useContext(SettingContext)
    const scheduledPickupContext = useContext(ScheduledPickupContext)
    const dynamicContext = useContext(DynamicContext)
    const alertContext = useContext(AlertContext)
    const { erp_tablefields, project_dynamicfields, propertyColumnReOrder } =
        dynamicContext
    const { setAlert } = alertContext
    const [tableBodyOne, setTableBodyOne] = useState([])
    const [tableBodyTwo, setTableBodyTwo] = useState([])
    const [tableBodyThree, setTableBodyThree] = useState([])
    const [tableBodyFour, setTableBodyFour] = useState([])
    const [tableDataOne, setTableDataOne] = useState({})
    const [tableDataTwo, setTableDataTwo] = useState({})
    const [tableDataThree, setTableDataThree] = useState({})
    const [tableDataFour, setTableDataFour] = useState({})
    const [value, setValue] = useState(0)
    const [tableValue, setTableValue] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const history = useHistory()
    const [reload, setReload] = useState(false)
    const [custom, setCustom] = useState({})
    const [mainID, setMainID] = useState(0)
    const [isLoading, setIsLoading] = useState(true)
    const {
        getAllScheduledPickup,
        changeProductStatus,
        all_scheduled_pickup,
        responseStatus,
        clearResponse,
        schedulePickupAction,
        waiting_scheduled_pickup,
        completed_scheduled_pickup,
        booking_scheduled_pickup,
        serving_scheduled_pickup,
    } = scheduledPickupContext

    const authContext = useContext(AuthContext)
    const { user } = authContext
    const toggleImageEditFullScreenPopup = (popup, id) => {}

    const [aucId, setAucId] = useState('')
    const [lotStatus, setLotStatus] = useState('draft')
    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        type: null,
    })
    const onClickEdit = (id, secondaryID, type) => {
        setValue(
            secondaryID == 'one'
                ? 1
                : secondaryID == 'two'
                ? 2
                : secondaryID == 'three'
                ? 3
                : 4
        )
        setMainID(id)
        setChangeStatus(true)
    }

    const submitFunction = (id) => {
        let data = { id: mainID }
        data.schedule_status =
            value === 1
                ? 'waiting'
                : value === 2
                ? 'serving'
                : value === 3
                ? 'completed'
                : 'completed'
        data[
            value === 1
                ? 'waiting_date'
                : value === 2
                ? 'serving_date'
                : value === 3
                ? 'completed_date'
                : 'completed_date'
        ] = moment(
            dateTimeFormatFunction(new Date()),
            'MM-DD-YYYY h:mm a'
        ).format()

        schedulePickupAction(data)
    }

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            order: '',
            sameday: true,
            start_date: moment().startOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
            end_date: moment().endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
            filters: {
                status: {
                    type: 'in',
                    value: '',
                    field: 'schedule_status',
                },
                name: {
                    type: 'like',
                    value: '',
                    field: 'name',
                },
                name: {
                    type: 'like',
                    value: '',
                    field: 'name',
                },
            },
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            formik.values.filters.status.value = 'booking'
            values.action = 'booking'
            getAllScheduledPickup(values, 'one')
            formik.values.filters.status.value = 'waiting'
            values.action = 'waiting'
            getAllScheduledPickup(values, 'two')
            formik.values.filters.status.value = 'serving'
            values.action = 'serving'
            getAllScheduledPickup(values, 'three')
            formik.values.filters.status.value = 'completed'
            values.action = 'completed'
            getAllScheduledPickup(values, 'four')
            setTimeout(() => {
                setIsLoading(false)
                setReload(!reload)
            }, 2000)
        },
    })
    useEffect(() => {
        formik.handleSubmit()
    }, [])

    useEffect(() => {
        if (
            booking_scheduled_pickup &&
            booking_scheduled_pickup.from == 'one'
        ) {
            if (booking_scheduled_pickup.records.length) {
                setTableDataOne({ ...booking_scheduled_pickup })
                booking_scheduled_pickup.records.map((ele) => {
                    ele.from = 'one'
                    ele.timeWaited = calculateRemainingTime(
                        ele.booking_start_date
                    )
                })
                console.log('======booking', booking_scheduled_pickup.records)
                setTableBodyOne(
                    booking_scheduled_pickup.records.length
                        ? booking_scheduled_pickup.records
                        : []
                )
            } else {
                setTableDataOne({})
                setTableBodyOne([])
            }
        }
    }, [booking_scheduled_pickup])
    useEffect(() => {
        if (
            waiting_scheduled_pickup &&
            waiting_scheduled_pickup.from == 'two'
        ) {
            if (waiting_scheduled_pickup.records.length) {
                setTableDataTwo({ ...waiting_scheduled_pickup })
                waiting_scheduled_pickup.records.map((ele) => {
                    ele.from = 'two'
                    ele.timeWaited = calculateRemainingTime(ele.waiting_date)
                })
                console.log('======waiting', waiting_scheduled_pickup.records)
                setTableBodyTwo(
                    waiting_scheduled_pickup.records.length
                        ? waiting_scheduled_pickup.records
                        : []
                )
            } else {
                setTableDataTwo({})
                setTableBodyTwo([])
            }
        }
    }, [waiting_scheduled_pickup])
    useEffect(() => {
        if (
            serving_scheduled_pickup &&
            serving_scheduled_pickup.from == 'three'
        ) {
            if (serving_scheduled_pickup.records.length) {
                setTableDataThree({ ...serving_scheduled_pickup })
                serving_scheduled_pickup.records.map((ele) => {
                    ele.from = 'three'
                    ele.timeWaited = calculateRemainingTime(ele.serving_date)
                })
                console.log('======serving', serving_scheduled_pickup.records)
                setTableBodyThree(
                    serving_scheduled_pickup.records.length
                        ? serving_scheduled_pickup.records
                        : []
                )
            } else {
                setTableDataThree({})
                setTableBodyThree([])
            }
        }
    }, [serving_scheduled_pickup])
    useEffect(() => {
        if (
            completed_scheduled_pickup &&
            completed_scheduled_pickup.from == 'four'
        ) {
            if (completed_scheduled_pickup.records.length) {
                setTableDataFour({ ...completed_scheduled_pickup })
                completed_scheduled_pickup.records.map((ele) => {
                    ele.from = 'four'
                    ele.timeWaited = calculateRemainingTime2(
                        ele.serving_date,
                        ele.completed_date
                    )
                })
                setTableBodyFour(
                    completed_scheduled_pickup.records.length
                        ? completed_scheduled_pickup.records
                        : []
                )
            } else {
                setTableDataFour({})
                setTableBodyFour([])
            }
        }
    }, [completed_scheduled_pickup])

    useEffect(() => {
        if (
            responseStatus &&
            (responseStatus.from == 'popupSubmit' ||
                responseStatus.from == 'scheduledPickupAction')
        ) {
            if (responseStatus.status === 'success') {
                if (responseStatus.from == 'scheduledPickupAction') {
                    setAlert('Successfully Updated', responseStatus.status)
                    setMainID(0)
                    formik.handleSubmit()
                    setChangeStatus(false)
                } else if (responseStatus.from == 'popupSubmit') {
                    setAlert('Successfully Added', responseStatus.status)
                    formik.handleSubmit()
                    setManage(false, 'new', null)
                }
            } else {
                setAlert(
                    responseStatus.message
                        ? responseStatus.message
                        : 'Internal server error',
                    'error'
                )
            }
        }
    }, [responseStatus])
    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }
    const onClickUserEdit = (id, secondaryID, type) => {
        if (user?.emp_type === 'super_admin' || user?.emp_type === 'admin') {
            handleRedirectInternal(history, `user/edit/${id}`)
        }
    }
    const tableValues = [
        {
            field: 'name',

            clickID: 'user_id',
            onclick: onClickUserEdit,
            type: 'hyperlink',

            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Name',
            showTable: [1, 2, 3, 4],
        },
        {
            field: 'phone',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Phone Number',
            showTable: [1, 2, 3, 4],
        },
        {
            field: 'email',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Email',
            showTable: [1, 2, 3, 4],
        },
        {
            field: 'invoice_id',
            clickID: 'invoice_id',
            onclick: onClickInvoiceEdit,
            type: 'hyperlink',
            secondaryClickID: 'user_id',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
            showTable: [1, 2, 3, 4],
        },
        {
            field: 'booking_start_date',
            type: 'datetime',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Booking Time',
            showTable: [1, 2, 3, 4],
        },
        // {
        //     field: 'timeWaited',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'Time Waited',
        //     showTable: [1, 2, 3, 4],
        // },
        {
            field: 'completed_date',
            type: 'datetime',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Completed Time',
            showTable: [1, 2, 3, 4],
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            clickID: 'id',
            sort: false,
            clickType: 'edit',
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            onclick: onClickEdit,
            secondaryClickID: 'from',
            buttonType: 'edit',
            tableShow: 1,
            showTable: [1, 2, 3],
        },
    ]

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            setValue(newValue)
        } else if (newValue === 1) {
            formik.values.filters.status.value = 'booking'
            setValue(newValue)
        } else if (newValue === 2) {
            formik.values.filters.status.value = 'waiting'
            setValue(newValue)
        } else if (newValue === 3) {
            formik.values.filters.status.value = 'serving'
            setValue(newValue)
        } else if (newValue === 4) {
            formik.values.filters.status.value = 'completed'
            setValue(newValue)
        } else if (newValue === 5) {
            formik.values.filters.status.value = 'no_show'
            setValue(newValue)
        }
    }

    const additionalFilterCallBack = (data) => {
        setLotStatus(data.lots)
        setAucId(data.auctions)
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }
    const searchInfo = [
        {
            label: 'Name',
            placeholder: 'Search Customer Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'name',
            formik: formik,
            filter: true,
        },
    ]
    const changeChangeStatus = () => {
        setChangeStatus(false)
    }
    const togglePopup = (popup, status, type) => {
        if (popup) {
            setManage({ popup, status, type })
        } else {
            setManage({ popup, status: 'new', type: null })
        }
    }
    const submitPopupFunction = (values) => {
        let dateFields = ['booking_start_date', 'booking_end_date']
        let newObj = { ...values }
        dateFields.map((ele) => {
            newObj[ele] = moment(
                dateTimeFormatFunction(newObj[ele] ? newObj[ele] : new Date()),
                'MM-DD-YYYY h:mm a'
            ).format()
        })

        schedulePickupAction(newObj, 'popupSubmit')
    }
    return (
        <>
            <div className="dashboard listing maillisting erpMisc">
                {/* <CustomSearch searchInfo={searchInfo} formik={formik} /> */}
                <OrderManager
                    data={manage}
                    function={togglePopup}
                    submitFunction={submitPopupFunction}
                ></OrderManager>
                <div className="ordersHeader fchild">
                    <h5>
                        Today&apos;s Booking
                        <span>
                            {' '}
                            {tableDataOne?.totalRecords
                                ? `${tableDataOne?.totalRecords} Customers`
                                : `0 Customers`}
                        </span>
                    </h5>
                    <Button
                        className="ohAdd"
                        onClick={() => togglePopup(true, 'new', 'one')}
                    >
                        <span className="material-icons">
                            add_circle_outline
                        </span>{' '}
                        Add
                    </Button>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBodyOne}
                    tableValues={tableValues.filter((ele) =>
                        ele.showTable.includes(1)
                    )}
                    tableActions={[]}
                    allData={tableDataOne}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllScheduledPickup}
                    hideCompactView={props.hideCompactView}
                />
                <div className="ordersHeader">
                    <h5>
                        Waitlist
                        <span>
                            {' '}
                            {tableDataTwo?.totalRecords
                                ? `${tableDataTwo?.totalRecords} Customers`
                                : `0 Customers`}
                        </span>
                    </h5>
                    <Button
                        className="ohAdd"
                        onClick={() => togglePopup(true, 'new', 'two')}
                    >
                        <span className="material-icons">
                            add_circle_outline
                        </span>{' '}
                        Add
                    </Button>
                </div>

                <CustomTable
                    formik={formik.values}
                    tableBody={tableBodyTwo}
                    tableValues={tableValues.filter((ele) =>
                        ele.showTable.includes(2)
                    )}
                    tableActions={[]}
                    allData={tableDataTwo}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllScheduledPickup}
                    hideCompactView={props.hideCompactView}
                />
                <div className="ordersHeader">
                    <h5>
                        Serving
                        <span>
                            {tableDataThree?.totalRecords
                                ? `${tableDataThree?.totalRecords} Customers`
                                : `0 Customers`}
                        </span>
                    </h5>
                    <Button
                        className="ohAdd"
                        onClick={() => togglePopup(true, 'new', 'three')}
                    >
                        <span className="material-icons">
                            add_circle_outline
                        </span>{' '}
                        Add
                    </Button>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBodyThree}
                    tableValues={tableValues.filter((ele) =>
                        ele.showTable.includes(3)
                    )}
                    tableActions={[]}
                    allData={tableDataThree}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllScheduledPickup}
                    hideCompactView={props.hideCompactView}
                />

                <div className="ordersHeader">
                    <h5>
                        Today Completed
                        <span>
                            {tableDataFour?.totalRecords
                                ? `${tableDataFour?.totalRecords} Customers`
                                : `0 Customers`}
                        </span>
                    </h5>
                    <Button
                        className="ohAdd"
                        onClick={() => togglePopup(true, 'new', 'four')}
                    >
                        <span className="material-icons">
                            add_circle_outline
                        </span>{' '}
                        Add
                    </Button>
                </div>

                <CustomTable
                    formik={formik.values}
                    tableBody={tableBodyFour}
                    tableValues={tableValues.filter((ele) =>
                        ele.showTable.includes(4)
                    )}
                    tableActions={[]}
                    allData={tableDataFour}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllScheduledPickup}
                    hideCompactView={props.hideCompactView}
                />
                <CustomDialog
                    title={'Change Scheduled Pickup status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                >
                    <h5>{`Are you sure you want to change the status from ${
                        value === 1
                            ? 'Booking'
                            : value === 2
                            ? 'Waitlist'
                            : value === 3
                            ? 'Serving'
                            : ''
                    } to ${
                        value === 1
                            ? 'Waitlist'
                            : value === 2
                            ? 'Serving'
                            : value === 3
                            ? 'Completed'
                            : ''
                    } `}</h5>
                    <div className="actionWrapper">
                        <Button
                            id="bidDeposit_cancel"
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>

                        <PrimaryButton
                            id="bidDeposit_submit"
                            onClick={() => submitFunction()}
                            label="Confirm"
                        />
                    </div>
                </CustomDialog>
            </div>
        </>
    )
}

export default AllOrders
